import Flex, { GAP_CLASS } from "components/Flex";
import UserAvatar from "components/UserAvatar";
import React from "react";
import { formatCompactCurrency } from "utils/currency";
import { toInitials } from "utils/toInitials";

import styles from "./PipelineByOwnerModal.module.scss";

export const createColumns = (currency) => [
  {
    header: "Assignee",
    accessorKey: "ownerName",
    id: "ownerName",
    enableSorting: false,
    cell: ({ row }) => {
      const { ownerName, workspaceUserId } = row.original;
      return (
        <Flex
          data-testid={`modal-owner-row-${workspaceUserId}`}
          gap={GAP_CLASS.GAP_200}
        >
          <UserAvatar initials={toInitials(ownerName)} name={ownerName} />
          <span className={styles.pipelineByOwnerModal__name} title={ownerName}>
            {ownerName}
          </span>
        </Flex>
      );
    },
  },
  {
    header: "Opportunities",
    accessorKey: "opportunityCount",
    id: "opportunityCount",
    enableSorting: false,
    cell: ({ row }) => (
      <span className={styles.pipelineByOwnerModal__count}>
        {row.original.opportunityCount}
      </span>
    ),
  },
  {
    header: "Value",
    accessorKey: "value",
    id: "value",
    enableSorting: false,
    cell: ({ row }) => {
      const { value, barWidthPercent } = row.original;
      return (
        <Flex gap={GAP_CLASS.GAP_200}>
          <div className={styles.pipelineByOwnerModal__barTrack}>
            <div
              className={styles.pipelineByOwnerModal__barFill}
              style={{ "--bar-width": `${barWidthPercent}%` }}
            />
          </div>
          <span className={styles.pipelineByOwnerModal__valueLabel}>
            {formatCompactCurrency(value, currency)}
          </span>
        </Flex>
      );
    },
  },
];
